import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import { useHistory ,Link} from "react-router-dom";
import Box from "@mui/material/Box";
import React, { useState } from "react";
import { useSnackbar } from "notistack";
import "./Header.css";

const Header = ({ children, hasHiddenAuthButtons }) => {

  // Use History Hook for programmatically changing location
  const history = useHistory() ;

  // Redirecting to products page for register/Login pages
  const redirectToProductsPage = () => {
    history.push("/", {from : "Header"});
  }

  // Force Reloading on logout from Products page
  let logout = () => {
    localStorage.clear();
    window.location.reload();
  }

// All Button Combinations
const backToExploreButton = <Button
                                className="explore-button"
                                startIcon={<ArrowBackIcon />}
                                variant="text"
                                onClick = {redirectToProductsPage}
                              >
                                Back to explore
                              </Button> ;

const logOutButton= <Stack direction="row" spacing={1} alignItems="center" key="logout">
                        <Avatar src="avatar.png" alt="crio.do" />
                        <b>{localStorage.getItem("username")}</b>
                        <Button className="link" onClick={logout}>Logout</Button>
                    </Stack>

const loginRegisterButtons = <Stack direction="row" spacing={1} key="login">
                                <Link className="link" to="/login"><Button  variant="text">Login</Button></Link>
                                <Link className="link" to="/register"><Button  variant="contained" >Register</Button></Link>
                             </Stack>

// Products page button combo based on Login Status
const buttonsBasedOnLoginStatus = localStorage.getItem("username") ? logOutButton : loginRegisterButtons;


    return (
      <Box className="header">
        <Box className="header-title">
            <img src="logo_light.svg" alt="QKart-icon"></img>
        </Box>
        {children}
        {hasHiddenAuthButtons ? buttonsBasedOnLoginStatus : backToExploreButton}
      </Box>
    );
};

export default Header;
